// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"516":"dc497426","616":"dc497426","636":"abb48ea9"}[chunkId] + ".chunk.css";
};